var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('img',{staticClass:"d-block item-img",attrs:{"loading":"lazy","src":_vm.files + _vm.item.img + '?resize=1&w=600',"alt":_vm.item.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }